import { User } from "common/interfaces/api";
import { ForumCommentType } from "service/forum";

export const isMyComment = (comment: ForumCommentType, currentUser: User) => {
  if (!comment || !currentUser) return false;
  return comment?.user_info?.id === currentUser?.id;
};
